import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import * as locales from './locales';

const currentLang = localStorage.getItem('lang');

const resources = {
  en: {
    translation: locales.en
  },
  pt: {
    translation: locales.pt
  },
  es: {
    translation: locales.es
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: currentLang ?? "pt", 
    fallbackLng: "pt",

    interpolation: {
      escapeValue: false
    }
});

export default i18n;